import { Currency, DealPartner, DmpAudienceProvider, ExchangeRate, PlatformFeeEnum } from '@/app/shared/_models/models';
import { SharedStoreService } from '@/app/shared/_services/shared-store.service';
import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';
import { SharedService } from '../../../shared/_services/shared.service';
import { AbstractControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { map, take, takeUntil } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
export type PartnerInfoMode = 'create' | 'edit' | 'disabled';

@Component({
  selector: 'app-deal-partner-info',
  templateUrl: './deal-partner-info.component.html',
  styleUrls: ['./deal-partner-info.component.less']
})
export class DealPartnerInfoComponent implements OnInit, OnChanges {
  @Input() mode: PartnerInfoMode = 'create';
  @Input() partner: DealPartner;
  @Input() dmpAudienceProviders: DmpAudienceProvider[] = [];
  @Input() form: FormGroup;
  @Output() statusChange = new EventEmitter<boolean>();
  @Output() delete = new EventEmitter<void>();

  platformFeeOptions: { value: string; displayName: string }[] = [];

  availableAudienceProviders: DmpAudienceProvider[] = [];
  private readonly demandMarginPercentageValidators = [
    (control: AbstractControl): ValidationErrors | null => {
      const value = control?.value;
      if (value && (value < 0 || value > 80)) {
        return { marginRange: 'Client Margin must be between 0-80%' };
      }
      return null;
    }
  ];


  constructor(
    private sharedStoreService: SharedStoreService
  ) {}

  ngOnInit() {
    this.initializePlatformFeeType();
    this.initializeAudienceProviders();
    this.initDisabledMode();
    this.form.get('defaultDemandMargin').setValidators(this.demandMarginPercentageValidators);
    this.form.get('defaultDemandMargin').updateValueAndValidity();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.partner && changes.partner.currentValue && this.form) {
      if (this.partner?.platformFeeType) {
        const matchingOption = this.platformFeeOptions.find(
          option => option.value.toLowerCase() === this.partner.platformFeeType.toLowerCase()
        );

        if (matchingOption) {
          this.form.get('platformFeeType').setValue(matchingOption.value);
        }
      }
    }
  }
  
  private initDisabledMode(){
    if (this.mode === 'disabled') {
      if (this.partner?.platformFeeType) {
        const matchingOption = this.platformFeeOptions.find(
          option => option.value.toLowerCase() === this.partner.platformFeeType.toLowerCase()
        );

        if (matchingOption) {
          this.form.get('platformFeeType').setValue(matchingOption.value);
        }
      }
      this.form.disable();
    }
  }

  private initializeAudienceProviders() {
    const uniqueProviderIds = new Set<number>();

    this.availableAudienceProviders = [...this.dmpAudienceProviders];
    this.dmpAudienceProviders.forEach(provider => {
      uniqueProviderIds.add(provider.providerId);
    });

    if (this.mode !== 'create' && this.partner?.audienceProviders) {
      this.partner.audienceProviders.forEach(provider => {
        if (!uniqueProviderIds.has(provider.providerId)) {
          this.availableAudienceProviders.push(provider);
          uniqueProviderIds.add(provider.providerId);
        }
      });
    }
  }

  private initializePlatformFeeType() {
    this.sharedStoreService.getSharedEnum('PartnerPlatformFeeType').pipe(
      take(1),
      map(response => Object.entries(response).map(([value, displayName]) => ({
        value: value,
        displayName: displayName
      })))
    ).subscribe(platformFeeTypes => {
      this.platformFeeOptions = platformFeeTypes.sort((a, b) =>
        a.displayName.localeCompare(b.displayName)
      );
      if (this.partner?.platformFeeType) {
        this.form.get('platformFeeType').setValue(this.partner.platformFeeType.toLowerCase());
      }
    });
  }
}
